module.exports = __webpack_public_path__ + "media/src/admin/images/bg-270ea1be515d55cd6b2d057b95333f06.jpg";